/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { EventGroupSeo } from '@app/events/events-groups/event-group-seo.model';
import { Type } from '@app/settings/types/types.model';
import { Venue } from '@app/settings/venues/venue.model';
import { Industry } from '@app/settings/industries/industries.model';

export class EventGroup extends Model {
  id: number;
  name: string;
  web_name: string;
  founded_year: string;
  industry_id: number;
  industry?: Industry;
  priority_id: number;
  priority?: Type;
  repeat_id: number;
  repeat: Type;
  organizer: string;
  visitors: number;
  exhibitors: number;
  foreign_exhibitors: number;
  website_url: string;
  link_exhibitors: string;
  year_exhibitors: number;
  venue_id: number;
  venue?: Venue;
  active: boolean;
  show_to_web: boolean;
  translations: Array<EventGroupSeo>;
  tags: Array<string>;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.priority) {
      this.priority = new Type().deserialize(input.priority);
    }

    if (input.repeat) {
      this.repeat = new Type().deserialize(input.repeat);
    }

    if (input.venue) {
      this.venue = new Venue().deserialize(input.venue);
    }

    if (input.industry) {
      this.industry = new Industry().deserialize(input.industry);
    }

    return this;
  }
}
